import React from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { Icon } from 'Components/frameworks/icon/Icon';
export const HeaderCriteriaAttendees = ({ selectedProposal }: { selectedProposal: Proposal }) => {
  const attendeesNumber =
    selectedProposal.attendees.adults.length + selectedProposal.attendees.children.length;
  return (
    <span
      className="flex min-w-80 max-w-80 flex-1 items-center justify-center gap-10 rounded-8 border-1 border-solid border-white p-10 text-12 leading-1 text-white sm:flex-none md:max-w-none"
      data-testid="edit-my-criteria-who"
    >
      <Icon width="1.25rem" name={ICONS.PEOPLE_DOUBLE} />
      <span className="font-bold underline" data-testid="HeaderCriteriaAttendees-attendeesNumber">
        {attendeesNumber}
      </span>
    </span>
  );
};
